import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["textInput"];
function TextInputComponent_label_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function TextInputComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 7);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TextInputComponent_label_1_span_2_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("label-disabled", ctx_r0.disabled)("read-only-label", ctx_r0.readonly);
    i0.ɵɵattribute("for", ctx_r0.id || ctx_r0.defaultId)("aria-label", ctx_r0.ariaLabel || null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.labelText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.required && !ctx_r0.disabled);
  }
}
function TextInputComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TextInputComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TextInputComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r4.errorMessageText, " ");
  }
}
let inputTextCount = 0;
class TextInputComponent {
  constructor(cdr, elementRef) {
    this.cdr = cdr;
    this.elementRef = elementRef;
    /**
     * @deprecated This is no longer required. It works based on labelText and required property
     */
    this.labelVarient = 'label';
    this.labelText = '';
    this.placeholderText = 'Placeholder';
    this.disabled = false;
    this.name = '';
    this.id = '';
    this.required = false;
    this.readonly = false;
    this.autocomplete = 'off';
    this.errorMessageText = null;
    this.ariaLabel = '';
    this.ariaLabelledby = null;
    this.leadingIcon = null;
    this.trailingIcon = null;
    this.value = '';
    this.errorState = false;
    this.type = 'text';
    this.valueChange = new EventEmitter();
    this.highlightedText = new EventEmitter();
    /**
     * placeholder declarations. Replaced by the functions provided to `registerOnChange` and `registerOnTouched`
     */
    this.onChangeHandler = _ => {};
    this._onTouchedHandler = () => {};
    inputTextCount++;
    this.defaultId = `sol-text-input-${inputTextCount}`;
  }
  onInputContainerClick() {
    this.textInput.nativeElement.focus();
  }
  handleSelection() {
    const selection = document.getSelection();
    if (selection && selection.rangeCount > 0) {
      this.highlightedText.emit(selection.toString());
    }
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      this.value = '';
    }
    this.cdr.markForCheck();
  }
  /**
   * Registers a listener that notifies the model when the control updates
   */
  registerOnChange(fn) {
    this.onChangeHandler = fn;
  }
  /**
   * Registers a listener that notifies the model when the control is blurred
   */
  registerOnTouched(fn) {
    this._onTouchedHandler = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    if (this.textInput) {
      this.textInput.nativeElement.disabled = this.disabled;
    }
    this.cdr.markForCheck();
  }
  /**
   * Handles the input event from the `input`.
   * Sends events to the change handler and emits a value.
   */
  onInput(event) {
    this.value = event.target.value;
    this.onChangeHandler(this.value);
    this.valueChange.emit(this.value);
  }
  onChange(event) {
    event.stopPropagation();
  }
  /**
   * Listens for the host blurring, and notifies the model
   */
  focusOut() {
    this._onTouchedHandler();
  }
  static {
    this.ɵfac = function TextInputComponent_Factory(t) {
      return new (t || TextInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TextInputComponent,
      selectors: [["sol-text-input"]],
      viewQuery: function TextInputComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textInput = _t.first);
        }
      },
      hostBindings: function TextInputComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function TextInputComponent_focusout_HostBindingHandler() {
            return ctx.focusOut();
          });
        }
      },
      inputs: {
        labelVarient: "labelVarient",
        labelText: "labelText",
        placeholderText: "placeholderText",
        disabled: "disabled",
        name: "name",
        id: "id",
        required: "required",
        readonly: "readonly",
        autocomplete: "autocomplete",
        errorMessageText: "errorMessageText",
        ariaLabel: [i0.ɵɵInputFlags.None, "aria-label", "ariaLabel"],
        ariaLabelledby: [i0.ɵɵInputFlags.None, "aria-labelledby", "ariaLabelledby"],
        leadingIcon: "leadingIcon",
        trailingIcon: "trailingIcon",
        value: "value",
        errorState: "errorState",
        type: "type"
      },
      outputs: {
        valueChange: "valueChange",
        highlightedText: "highlightedText"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TextInputComponent,
        multi: true
      }])],
      decls: 8,
      vars: 22,
      consts: [[1, "sol-text-input"], ["class", "sol-text-input-label", 3, "label-disabled", "read-only-label", 4, "ngIf"], [1, "sol-input-container", 3, "click"], [4, "ngTemplateOutlet"], [1, "sol-input", 3, "type", "id", "value", "placeholder", "disabled", "required", "readonly", "autocomplete", "input", "change", "select"], ["textInput", ""], ["class", "error-message", 4, "ngIf"], [1, "sol-text-input-label"], ["class", "required-label", 4, "ngIf"], [1, "required-label"], [1, "error-message"]],
      template: function TextInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TextInputComponent_label_1_Template, 3, 8, "label", 1);
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵlistener("click", function TextInputComponent_Template_div_click_2_listener() {
            return ctx.onInputContainerClick();
          });
          i0.ɵɵtemplate(3, TextInputComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
          i0.ɵɵelementStart(4, "input", 4, 5);
          i0.ɵɵlistener("input", function TextInputComponent_Template_input_input_4_listener($event) {
            return ctx.onInput($event);
          })("change", function TextInputComponent_Template_input_change_4_listener($event) {
            return ctx.onChange($event);
          })("select", function TextInputComponent_Template_input_select_4_listener() {
            return ctx.handleSelection();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, TextInputComponent_ng_container_6_Template, 1, 0, "ng-container", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, TextInputComponent_span_7_Template, 2, 1, "span", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.labelText);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("read-only", ctx.readonly)("disabled", ctx.disabled)("error-border", ctx.errorMessageText || ctx.errorState);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.leadingIcon);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("error-border", ctx.errorMessageText);
          i0.ɵɵproperty("type", ctx.type || "text")("id", ctx.id || ctx.defaultId)("value", ctx.value || "")("placeholder", ctx.placeholderText)("disabled", ctx.disabled)("required", ctx.required)("readonly", ctx.readonly)("autocomplete", ctx.autocomplete || "off");
          i0.ɵɵattribute("name", ctx.name)("aria-labelledby", ctx.ariaLabelledby);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.trailingIcon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.errorMessageText);
        }
      },
      dependencies: [i1.NgIf, i1.NgTemplateOutlet],
      styles: [".sol-text-input{display:block}.sol-text-input .read-only-label{color:var(--color-interface-text800)}.sol-text-input .sol-input-container{box-sizing:border-box;height:2.25rem;padding:.063rem .75rem 0;gap:1rem;border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-inactive-border);border-radius:var(--radii-small-allcorners);background-color:#fff;display:inline-flex;align-items:center;width:100%}.sol-text-input .sol-input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-text-input .sol-input-container:focus-within{border-color:#00000080}.sol-text-input .sol-input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-text-input .sol-input-container.error-border:active,.sol-text-input .sol-input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-text-input .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-text-input .disabled svg path{fill:#c3c5c9}.sol-text-input .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-text-input .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-text-input .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-text-input label.sol-text-input-label{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:.25rem}.sol-text-input label.sol-text-input-label .required-label{color:var(--color-button-destructive-hover);padding-left:.25rem}.sol-text-input .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input{height:100%;width:100%;border-style:none;border-width:0;border-color:transparent;box-sizing:border-box;background-color:#fff;outline:none;padding:0;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-text-input input.sol-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-text-input input.sol-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-text-input input.sol-input:disabled{pointer-events:none;background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input[type=search]::-webkit-search-cancel-button{appearance:none;height:.75rem;width:.75rem;border-radius:0;background:url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.3125 6.04651L11.7188 1.67442C12.0938 1.30233 12.0938 0.744186 11.7188 0.372093C11.3438 -6.93077e-08 10.7812 -6.93077e-08 10.4062 0.372093L6 4.74419L1.59375 0.27907C1.21875 -0.0930233 0.65625 -0.0930233 0.28125 0.27907C-0.09375 0.651163 -0.09375 1.2093 0.28125 1.5814L4.6875 6.04651L0.28125 10.4186C-0.09375 10.7907 -0.09375 11.3488 0.28125 11.7209C0.65625 12.093 1.21875 12.093 1.59375 11.7209L6 7.34884L10.4062 11.7209C10.7812 12.093 11.3438 12.093 11.7188 11.7209C12.0938 11.3488 12.0938 10.7907 11.7188 10.4186L7.3125 6.04651Z' fill='%23829AAB'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%;background-size:contain;padding-left:.938rem;cursor:pointer}.sol-text-input .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextInputComponent, [{
    type: Component,
    args: [{
      selector: 'sol-text-input',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TextInputComponent,
        multi: true
      }],
      template: "<div class=\"sol-text-input\">\n  <label\n    class=\"sol-text-input-label\"\n    [class.label-disabled]=\"disabled\"\n    [class.read-only-label]=\"readonly\"\n    [attr.for]=\"id || defaultId\"\n    *ngIf=\"labelText\"\n    [attr.aria-label]=\"ariaLabel || null\"\n  >\n    {{ labelText }}\n    <span *ngIf=\"required && !disabled\" class=\"required-label\">*</span>\n  </label>\n  <div\n    (click)=\"onInputContainerClick()\"\n    class=\"sol-input-container\"\n    [class.read-only]=\"readonly\"\n    [class.disabled]=\"disabled\"\n    [class.error-border]=\"errorMessageText || errorState\"\n  >\n    <ng-container *ngTemplateOutlet=\"leadingIcon\"></ng-container>\n    <input\n      [type]=\"type || 'text'\"\n      [class.error-border]=\"errorMessageText\"\n      class=\"sol-input\"\n      [id]=\"id || defaultId\"\n      [value]=\"value || ''\"\n      [attr.name]=\"name\"\n      [placeholder]=\"placeholderText\"\n      [disabled]=\"disabled\"\n      [required]=\"required\"\n      [readonly]=\"readonly\"\n      [autocomplete]=\"autocomplete || 'off'\"\n      [attr.aria-labelledby]=\"ariaLabelledby\"\n      (input)=\"onInput($event)\"\n      (change)=\"onChange($event)\"\n      (select)=\"handleSelection()\"\n      #textInput\n    />\n    <ng-container *ngTemplateOutlet=\"trailingIcon\"></ng-container>\n  </div>\n  <span class=\"error-message\" *ngIf=\"errorMessageText\">\n    {{ errorMessageText }}\n  </span>\n</div>\n",
      styles: [".sol-text-input{display:block}.sol-text-input .read-only-label{color:var(--color-interface-text800)}.sol-text-input .sol-input-container{box-sizing:border-box;height:2.25rem;padding:.063rem .75rem 0;gap:1rem;border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-inactive-border);border-radius:var(--radii-small-allcorners);background-color:#fff;display:inline-flex;align-items:center;width:100%}.sol-text-input .sol-input-container:hover{border-color:var(--color-globalstate-hover-border)}.sol-text-input .sol-input-container:focus-within{border-color:#00000080}.sol-text-input .sol-input-container.error-border{border-color:var(--color-button-destructive-hover)}.sol-text-input .sol-input-container.error-border:active,.sol-text-input .sol-input-container.error-border:focus{border-color:var(--color-button-destructive-hover)}.sol-text-input .disabled{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);pointer-events:none;background-color:var(--color-globalstate-disabled-background)}.sol-text-input .disabled svg path{fill:#c3c5c9}.sol-text-input .read-only{outline:var(--color-globalstate-disabled-borderalt);border-style:solid;border-width:var(--border-size1);border-color:var(--color-globalstate-disabled-borderalt);color:var(--color-interface-text800);cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-text-input .read-only:focus-within{border-color:var(--color-globalstate-disabled-borderalt)}.sol-text-input .read-only:hover{border-color:var(--color-globalstate-disabled-borderalt)}.sol-text-input label.sol-text-input-label{font-family:var(--typography-opensans-body-overline-font-family);font-style:var(--typography-opensans-body-overline-font-style);font-weight:var(--typography-opensans-body-overline-font-weight);font-size:var(--typography-opensans-body-overline-font-size);line-height:1.021rem;letter-spacing:var(--typography-opensans-body-overline-letter-spacing);display:flex;align-items:center;text-transform:var(--typography-opensans-body-overline-text-case);color:var(--color-interface-text700);text-decoration:var(--typography-opensans-body-overline-text-decoration);font-stretch:var(--typography-opensans-body-overline-font-stretch);flex:none;order:0;flex-grow:0;margin-bottom:.25rem}.sol-text-input label.sol-text-input-label .required-label{color:var(--color-button-destructive-hover);padding-left:.25rem}.sol-text-input .label-disabled{color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input{height:100%;width:100%;border-style:none;border-width:0;border-color:transparent;box-sizing:border-box;background-color:#fff;outline:none;padding:0;font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);text-transform:var(--typography-opensans-body-body3-text-case);font-stretch:var(--typography-opensans-body-body3-font-stretch);text-decoration:var(--typography-opensans-body-body3-text-decoration);text-align:left;color:var(--color-interface-text700);display:flex}.sol-text-input input.sol-input:read-only{cursor:default;background-color:var(--color-globalstate-disabled-background)}.sol-text-input input.sol-input:read-only::placeholder{color:var(--color-interface-text800)}.sol-text-input input.sol-input:disabled{pointer-events:none;background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input:disabled::placeholder{color:var(--color-globalstate-disabled-content)}.sol-text-input input.sol-input[type=search]::-webkit-search-cancel-button{appearance:none;height:.75rem;width:.75rem;border-radius:0;background:url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.3125 6.04651L11.7188 1.67442C12.0938 1.30233 12.0938 0.744186 11.7188 0.372093C11.3438 -6.93077e-08 10.7812 -6.93077e-08 10.4062 0.372093L6 4.74419L1.59375 0.27907C1.21875 -0.0930233 0.65625 -0.0930233 0.28125 0.27907C-0.09375 0.651163 -0.09375 1.2093 0.28125 1.5814L4.6875 6.04651L0.28125 10.4186C-0.09375 10.7907 -0.09375 11.3488 0.28125 11.7209C0.65625 12.093 1.21875 12.093 1.59375 11.7209L6 7.34884L10.4062 11.7209C10.7812 12.093 11.3438 12.093 11.7188 11.7209C12.0938 11.3488 12.0938 10.7907 11.7188 10.4186L7.3125 6.04651Z' fill='%23829AAB'/%3E%3C/svg%3E%0A\") no-repeat 50% 50%;background-size:contain;padding-left:.938rem;cursor:pointer}.sol-text-input .error-message{color:var(--color-button-destructive-hover);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);text-transform:var(--typography-opensans-body-body4-text-case);letter-spacing:var(--typography-opensans-body-body4-letter-spacing);font-stretch:var(--typography-opensans-body-body4-font-stretch);text-decoration:var(--typography-opensans-body-body4-text-decoration);margin-top:.4rem;display:block}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }], {
    labelVarient: [{
      type: Input
    }],
    labelText: [{
      type: Input
    }],
    placeholderText: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    autocomplete: [{
      type: Input
    }],
    errorMessageText: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input,
      args: ['aria-label']
    }],
    ariaLabelledby: [{
      type: Input,
      args: ['aria-labelledby']
    }],
    leadingIcon: [{
      type: Input
    }],
    trailingIcon: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    errorState: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    highlightedText: [{
      type: Output
    }],
    textInput: [{
      type: ViewChild,
      args: ['textInput', {
        static: false
      }]
    }],
    focusOut: [{
      type: HostListener,
      args: ['focusout']
    }]
  });
})();
class TextInputModule {
  static {
    this.ɵfac = function TextInputModule_Factory(t) {
      return new (t || TextInputModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TextInputModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextInputModule, [{
    type: NgModule,
    args: [{
      declarations: [TextInputComponent],
      imports: [CommonModule],
      exports: [TextInputComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of text-input
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TextInputComponent, TextInputModule };
